<div class="sales-card">
    <div class="card-header">
      <div class="card-title">
        <strong>Sales</strong>
      </div>
      <div class="card-value">
        <span class="amount">₹{{ totalAmount | number }}</span>
      </div>
    </div>
    <div class="card-subtitle">{{ dateRange }} {{selectedYear}}</div>
    <canvas id="salesChart"></canvas>
  </div>
  